import { api } from "./api";

/**
 * AW-LDQ-003 -- the Agent Workspace tool reads, and only the reads.
 *
 * WHY THESE FIVE AND NO OTHERS
 * ----------------------------
 * Every call here is run-scoped. The backend resolves the run through
 * `get_account_bound_run` before anything else, so the Account boundary
 * and the owner/Account-admin rule are enforced server-side on each
 * one; this module adds no authorization of its own and must not be
 * read as if it did.
 *
 * `/runs/{id}/fields` and `/runs/{id}/quote_fields` are the AW-LDQ-002
 * endpoints that answer from the run's `script_version_snapshot`. The
 * mutable `/scripts/{id}/fields` and `/scripts/{id}/quote_fields` are
 * deliberately absent and must never be added as a fallback: they
 * answer with whatever the definitions are NOW, which is how an agent
 * ends up reading a field set that does not match the Script in front
 * of them. A guard test asserts this file names neither.
 *
 * NO WRITES
 * ---------
 * This phase is read-only. `POST /runs/{id}/data` and
 * `POST /runs/{id}/quote_values` exist and are deliberately not wrapped
 * -- ScriptPlay remains the authoritative writer, and two surfaces
 * writing the same rows needs a conflict decision nobody has made.
 */

/** Discovery field definitions, from the run's locked Script version. */
export async function getRunLockedFields(runId) {
  const res = await api.get(`/runs/${encodeURIComponent(runId)}/fields`);
  return res.data;
}

/** Quote field definitions, from the run's locked Script version. */
export async function getRunLockedQuoteFields(runId) {
  const res = await api.get(`/runs/${encodeURIComponent(runId)}/quote_fields`);
  return res.data;
}

/** Persisted Discovery answers for this run. */
export async function getRunData(runId) {
  const res = await api.get(`/runs/${encodeURIComponent(runId)}/data`);
  return res.data;
}

/** Persisted Quote values for this run. */
export async function getRunQuoteValues(runId) {
  const res = await api.get(`/runs/${encodeURIComponent(runId)}/quote_values`);
  return res.data;
}

/** The run's prospect subjects. Household is not a row here -- it is a
 *  derived subject the panels synthesise. */
export async function getRunProspects(runId) {
  const res = await api.get(`/runs/${encodeURIComponent(runId)}/prospects`);
  return res.data;
}
